export default "__VITE_ASSET__BNjvvuhw__"